import {Component, OnInit, ViewChild} from '@angular/core';
import {CachedFilesService} from "../../service/cached-files.service";
import {CachedFile} from "../../model/cached-files/CachedFile";
import {MatTableDataSource} from "@angular/material/table";
import {ToastrService} from "ngx-toastr";
import {MatSort} from "@angular/material/sort";
import {concatWith} from "rxjs/operators";
import {Observable} from "rxjs";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-cached-files',
  templateUrl: './cached-files.component.html',
  styleUrls: ['./cached-files.component.scss']
})
export class CachedFilesComponent implements OnInit {

  files: CachedFile[] = [];
  dataSource = new MatTableDataSource<CachedFile>(this.files);

  columns = ['Name', 'Path', 'Size', 'Delete'];

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  constructor(private cachedFilesService: CachedFilesService,
              private toastr: ToastrService,
              private titleService: Title) {

  }

  refreshList$ = new Observable(observer => {
    this.cachedFilesService.getCachedFilesList().subscribe({
      next: files => {
        this.files = files;
        this.dataSource.data = files;
        observer.next(true);
        observer.complete();
      }
    });
  });

  ngOnInit() {
    this.refreshList$.subscribe();
    this.titleService.setTitle('Filings Summary - Cached Files');

  }

  public deleteAll(): void {
    this.cachedFilesService.deleteAllFile().pipe(concatWith(this.refreshList$)).subscribe();
  }

  public refresh() {
    this.refreshList$.subscribe();
  }

  public deleteFile(file: CachedFile): void {
    const r = this.fileDeleter(file).pipe(concatWith(this.refreshList$));
    r.subscribe(x => {
    });
  }

  private fileDeleter(file: CachedFile): Observable<boolean> {
    return new Observable(observer => {
      this.cachedFilesService.deleteFile(file).subscribe({
        next: res => {
          this.toastr.info('File + ' + file.name + ' was deleted');
          observer.next(true);
        }, error: err => {
          this.toastr.error('Error deleting file: ' + err);
          observer.next(false);
        }, complete: () => {
          observer.complete();
        }
      });
    });
  }

  filterTable(event: any) {
    if (event.target.value) {
      this.dataSource.data = this.files.filter(m => m.name.includes(event.target.value));
    } else {
      this.dataSource.data = this.files;
    }
  }


}
